import { Store } from '../../../../Store';
import React, {
  useEffect,
  useReducer,
  useContext,
  useState,
  useCallback,
} from 'react';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getError } from '../../../../utils';
import axios from 'axios';

import { getReducer } from '../../../../utils';
import ModalLogin from '../../login/ModalLogin';
import LoadingBox from '../../../compoment/LoadingBox';
import MessageBox from '../../../compoment/MessageBox';
import formatDate from '../../../../format/formatDate';
import Avatar from '../../../../format/Avatar';

import '../css/comments.css';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS_COMMENTS':
      return { ...state, comments: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    case 'CREATE_SUCCESS':
      return {
        ...state,
        loading: false,
        comments: [action.payload, ...state.comments],
      };
    default:
      return state;
  }
};

const Comments = ({ ableId }) => {
  const MIN_MESSAGE_LENGTH = 10;

  const [{ loading, error, comments }, dispatch] = useReducer(
    getReducer(reducer),
    {
      comments: [],
      loading: true,
      error: '',
    }
  );

  const [modalShow, setModalShow] = useState(false);
  const [minMessage, setMinMessage] = useState(false);

  const [content, setContent] = useState('');

  const { state } = useContext(Store);
  const { userInfo } = state;

  console.log(ableId);
  const fetchData = useCallback(async () => {
    if (!ableId) return;
    dispatch({ type: 'FETCH_REQUEST' });
    try {
      const { data } = await axios.get(
        `/comment/post/public/shows?ableId=${ableId}`
      );
      dispatch({
        type: 'FETCH_SUCCESS_COMMENTS',
        payload: data.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        ),
      });
    } catch (err) {
      dispatch({ type: 'FETCH_FAIL', payload: err.message });
    }
  }, [ableId, dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (content.length <= MIN_MESSAGE_LENGTH) {
      setMinMessage(true);
      return;
    }

    const formData = {
      ableId,
      content,
    };

    try {
      dispatch({ type: 'CREATE_REQUEST' });
      const result = await axios.post('/comment/post/create', formData, {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      });
      toast.success(result.data.message);
      dispatch({ type: 'CREATE_SUCCESS' });
      await fetchData();
      setContent('');
      setMinMessage(false);
    } catch (err) {
      toast.error(getError(err) || 'Đã xảy ra lỗi!');
      dispatch({
        type: 'CREATE_FAIL',
      });
    }
  };

  return loading ? (
    <LoadingBox />
  ) : error ? (
    <MessageBox variant="danger"> {error} </MessageBox>
  ) : (
    <section className="comments mt-lg-5">
      <h3 className="mb-3">Bình luận</h3>
      {userInfo ? (
        <form onSubmit={handleSubmit} className="form-comment shadow-lg">
          <h4>Nội dung</h4>
          <div className="mb-3">
            <textarea
              name="message"
              className="form-control mb-1"
              placeholder="Nhập vào nội dung bình luận của bạn"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              required
            />
            {minMessage && (
              <p className="text-danger message-text">
                Nội dung phải có ít nhất {MIN_MESSAGE_LENGTH} ký tự!
              </p>
            )}
          </div>
          <div className="d-flex justify-content-end align-items-center">
            <button type="submit">Phản hồi</button>
          </div>
        </form>
      ) : (
        <div className="comments">
          <p>
            Nếu muốn bình luận cho bài viết này, bạn cần{' '}
            <span className="cmt-login" onClick={() => setModalShow(true)}>
              Đăng nhập
            </span>{' '}
            !
          </p>
          <ModalLogin show={modalShow} onHide={() => setModalShow(false)} />
        </div>
      )}

      {comments.map((comment, idx) => (
        <div className="item-comment  row">
          <div className="col-xl-1 col-2 item-img">
            {comment.user.avatar_url ? (
              <img
                className="img-user "
                src={comment.user.avatar_url}
                alt={comment.user.full_name}
              />
            ) : (
              <Avatar fullName={comment.user.full_name} />
            )}
          </div>
          <div className="col-xl-11 col-10 item-content">
            <div className="arrow"></div>
            <div className="d-sm-flex d-block">
              <h4>{comment.user.full_name}</h4>
              <h5>{formatDate(comment.createdAt)}</h5>
            </div>
            <p>{comment.content}</p>
          </div>
        </div>
      ))}
    </section>
  );
};
export default Comments;
